import KApp            from './KApp.vue'
import KCookies        from './KCoockies.vue'
import BtnWhatsappFixo from './BtnWhatsapp/BtnWhatsappFixo.vue'
import VPicture        from './VPicture.vue'

export const COMPONENTS = {
	KApp,
	KCookies,
	BtnWhatsappFixo,
	VPicture
}

export default function installComponents(App) {
	for (const [selector, options] of Object.entries(COMPONENTS)) {
		App.component(selector, options)
	}
}
